import { render, staticRenderFns } from "./RoomDialog.vue?vue&type=template&id=33223563&"
import script from "./RoomDialog.vue?vue&type=script&lang=js&"
export * from "./RoomDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports